import React from 'react'
import "./index.scss"

const Card =(props)=>{
  const {label, className,children, id , customClass} = props
  return (
    <div className={`${customClass} ${className}`} id ={id}>{children}</div>
  )
}

export default Card